import React, { useContext, useEffect, useState } from "react";
import Title from "../Title/Title";
import Table from "../Table/Table";
import overviewCards from "../Overview/OverviewCard/OverviewDummy";
import { FlinkContext } from "../../context/FlinkContext";
import Loading from "../Loading/Loading";
import DualAxisLinechart from "../Chart/DualAxisLinechart";
import Logger from "../../Helper/Logger.js";

function FlinkCarbon() {
  const carbonData = useContext(FlinkContext);
  const [carbon, setCarbon] = useState(null);
  useEffect(() => {
    setCarbon(carbonData.carbon);
  }, [carbonData]);

  return (
    <div id="carbon" className="Flink-container">
      {carbon ? (
        <>
          <Title title="Carbon" icon={overviewCards.carbon.icon} />
          <div className="row">
            <Logger op="Chart" id="17150" className="col-md-6 col-sm-12">
              <DualAxisLinechart
                yAxisTitle={carbon?.carbonChart[0]?.unit}
                yAxisTitleSecond={carbon?.carbonChart[1]?.unit}
                data={carbon?.carbonChart}
                minmax={1}
                colors={["#004474", "#70cff9"]}
                showLegend
              />
            </Logger>
            <Logger op="News" id="40112" className="col-md-6 col-sm-12">
              <Table
                date2={carbon.carbonTable.date2}
                date1={carbon.carbonTable.date1}
                firstThName="Carbon"
                showBtn="none"
                data={carbon.carbonTable.pricesTable}
              />
            </Logger>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default FlinkCarbon;
